import { formatCurrency } from '../../pledge-pay/pledge-pay-utils.js';

const MODAL_SELECTOR = '#viewRecurModal';

function modalRoot() {
    return $(MODAL_SELECTOR);
}

function resolveRecurPaymentMemberName(mainData) {
    if (!mainData || typeof mainData !== 'object') {
        return '';
    }
    const explicit = String(mainData.member_name || mainData.user_name || mainData.name || '').trim();
    if (explicit) {
        return explicit;
    }
    return String(mainData.first_name || '').trim() + ' ' + String(mainData.last_name || '').trim();
}

function fillRecurPaymentModalSummary(tableName, mainData) {
    const $modal = modalRoot();
    $modal.find('#frequency_header, #installment_header, #num_left_header, #pay_next_payment_head').show();
    if (!mainData || typeof mainData !== 'object') {
        return;
    }
    $modal.find('#pay_member_name').text(resolveRecurPaymentMemberName(mainData).trim());

    if (tableName === 'pledge') {
        $modal.find('#pay_campaign').text(mainData.title ?? '');
        $modal.find('#pay_description').text(mainData.description ?? '');
        $modal.find('#pay_date_pledged').text(window.convert_date(mainData.pledge_date));
        $modal.find('#pay_amount_due').text('$' + formatCurrency(mainData.balance_due));
        if (!mainData.frequency_id) {
            $modal.find('#frequency_header, #installment_header, #num_left_header, #pay_next_payment_head').hide();
            if (mainData.balance_due === 0) {
                $modal.find('#pay_amount_due').text('Paid');
            }
        } else {
            $modal.find('#pay_next_payment').text(window.convert_date(mainData.next_run_date));
            $modal.find('#pay_frequency').text(mainData.frequency_name ?? '');
        }
        return;
    }

    if (tableName === 'ongoing_donations') {
        $modal.find('#pay_campaign').text(mainData.title ?? '');
        $modal.find('#pay_description').text(mainData.comments ?? '');
        $modal.find('#pay_date_pledged').text(window.convert_date(mainData.date_initiated));
        $modal.find('#pay_amount_due').text('$' + formatCurrency(mainData.balance_due));
        $modal.find('#pay_next_payment').text(window.convert_date(mainData.next_run_date));
        $modal.find('#pay_frequency').text(mainData.frequency_name ?? '');
        return;
    }

    if (tableName === 'campaign_donations') {
        $modal.find('#pay_campaign').text(mainData.title ?? '');
        $modal.find('#pay_description').text(mainData.comments ?? '');
        $modal.find('#pay_date_pledged').text(window.convert_date(mainData.date_paid));
        $modal.find('#pay_amount_due').text('Paid');
        $modal.find('#frequency_header, #installment_header, #num_left_header, #pay_next_payment_head').hide();
    }
}

function fillRecurPaymentModalDuration(mainData) {
    if (!mainData || typeof mainData !== 'object') {
        return;
    }
    const $modal = modalRoot();
    if (mainData.original_duration !== 0) {
        $modal.find('#pay_original_duration').text(mainData.original_duration);
        $modal.find('#pay_payments_left').text(mainData.num_left);
        return;
    }
    $modal.find('#pay_original_duration, #pay_payments_left').text('Ongoing');
    $modal.find('#pay_amount_due').text('$' + formatCurrency(mainData.amount));
}

function resetRecurViewDetailsLink() {
    const $link = modalRoot().find('[data-action="view-recur-payment-details"]');
    $link.attr('hidden', true);
    $link.removeAttr('data-table-name');
    $link.removeAttr('data-record-id');
}

function bindRecurViewDetailsLink(tableName, recordId) {
    const $link = modalRoot().find('[data-action="view-recur-payment-details"]');
    if (!$link.length) {
        return;
    }
    $link.attr('data-table-name', tableName);
    $link.attr('data-record-id', String(recordId));
    $link.removeAttr('hidden');
}

export {
    fillRecurPaymentModalSummary,
    fillRecurPaymentModalDuration,
    resolveRecurPaymentMemberName,
    bindRecurViewDetailsLink,
    resetRecurViewDetailsLink,
};
